// Tijdelijke, publieke privacyverklaring op /privacy — tweetalig (nl/en).
import { useT, useCurrentLocale, setLocale } from '@/i18n/useT';
import '@/features/legal/PrivacyPage.css';

const UPDATED_DATE = '2026-09-27';

export default function PrivacyPage() {
  const t = useT();
  const locale = useCurrentLocale();

  return (
    <div className="privacy-page" data-testid="privacy-page-root">
      <div className="privacy-page__inner">
        <div
          className="privacy-lang-toggle"
          role="group"
          aria-label={t('privacy.langToggle.groupLabel')}
        >
          <button
            type="button"
            aria-pressed={locale === 'nl'}
            className={locale === 'nl' ? 'is-active' : ''}
            onClick={() => setLocale('nl')}
          >
            {t('privacy.langToggle.nl')}
          </button>
          <button
            type="button"
            aria-pressed={locale === 'en'}
            className={locale === 'en' ? 'is-active' : ''}
            onClick={() => setLocale('en')}
          >
            {t('privacy.langToggle.en')}
          </button>
        </div>

        <p className="privacy-eyebrow">{t('privacy.eyebrow')}</p>
        <h1>{t('privacy.title')}</h1>
        <p className="privacy-meta">
          {t('privacy.updated', undefined, { date: UPDATED_DATE })}
        </p>
        <p className="privacy-intro">{t('privacy.intro')}</p>
        <p className="privacy-notice">{t('privacy.placeholderNotice')}</p>

        <section className="privacy-section">
          <h2>{t('privacy.section1.heading')}</h2>
          <p>{t('privacy.section1.body')}</p>
        </section>

        <section className="privacy-section">
          <h2>{t('privacy.section2.heading')}</h2>
          <h3>{t('privacy.section2.accountHeading')}</h3>
          <ul>
            <li>{t('privacy.section2.accountLi1')}</li>
            <li>{t('privacy.section2.accountLi2')}</li>
            <li>{t('privacy.section2.accountLi3')}</li>
            <li>{t('privacy.section2.accountLi4')}</li>
          </ul>
          <h3>{t('privacy.section2.tasksHeading')}</h3>
          <p>{t('privacy.section2.tasksBody')}</p>
          <h3>{t('privacy.section2.gcalHeading')}</h3>
          <p>{t('privacy.section2.gcalBody')}</p>
          <h3>{t('privacy.section2.analyticsHeading')}</h3>
          <p>{t('privacy.section2.analyticsBody')}</p>
          <h3>{t('privacy.section2.sentryHeading')}</h3>
          <p>{t('privacy.section2.sentryBody')}</p>
        </section>

        <section className="privacy-section">
          <h2>{t('privacy.section3.heading')}</h2>
          <p>{t('privacy.section3.body')}</p>
        </section>

        <section className="privacy-section">
          <h2>{t('privacy.section4.heading')}</h2>
          <p>{t('privacy.section4.body')}</p>
        </section>

        <section className="privacy-section">
          <h2>{t('privacy.section5.heading')}</h2>
          <ul>
            <li>{t('privacy.section5.li1')}</li>
            <li>{t('privacy.section5.li2')}</li>
            <li>{t('privacy.section5.li3')}</li>
          </ul>
        </section>

        <section className="privacy-section">
          <h2>{t('privacy.section6.heading')}</h2>
          <p>{t('privacy.section6.body')}</p>
        </section>

        <section className="privacy-section">
          <h2>{t('privacy.section7.heading')}</h2>
          <p>{t('privacy.section7.body')}</p>
        </section>

        <section className="privacy-section">
          <h2>{t('privacy.section8.heading')}</h2>
          <p>{t('privacy.section8.body')}</p>
        </section>
      </div>
    </div>
  );
}
